import { GameManager } from './../../GameManager';
import { GameVars } from './../../GameVars';
export class TurretsList extends Phaser.GameObjects.Container {

    private index: number;

    constructor(scene: Phaser.Scene, index: number) {

        super(scene);

        this.x = 220;
        this.y = 10;

        this.index = index;

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.lineStyle(5, 0x000000);
        bck.strokeRect(0, 0, 410, 110);
        this.add(bck);

        for (let i = 0; i < 8; i++) {
            let img = new Phaser.GameObjects.Image(this.scene, 30 + 50 * i, 35, "texture_atlas_2", "tower_image_"  + (i + 1) + "_1");
            img.setScale(.75);
            this.add(img);

            if (i === 5) {
                img.setFrame("tower_image_7_1");
            } else if (i === 6){
                img.setFrame("tower_image_6_1");
            }

            let checkbox = new Phaser.GameObjects.Image(this.scene, 30 + 50 * i, 85, "texture_atlas_0", "checkbox_" + GameVars.gameData.levelsInfo[this.index].turrets[i]);
            checkbox.setInteractive();
            checkbox.on("pointerdown", () => {
                GameVars.gameData.levelsInfo[this.index].turrets[i]++; 
                if (GameVars.gameData.levelsInfo[this.index].turrets[i] === 4) {
                    GameVars.gameData.levelsInfo[this.index].turrets[i] = 0;
                }
                checkbox.setFrame("checkbox_" + GameVars.gameData.levelsInfo[this.index].turrets[i]);
                GameManager.writeGameData();
            }, this);
            this.add(checkbox);
        }
    }
}
